import React, { useEffect, useState } from 'react'
// import ReactDatePicker from 'react-datepicker'
import Select from 'react-select'
import getFormattedDate from '../Movie/getFormattedDate'
import PopularListTypeInMovies from './PopularListTypeInMovies'
import RatingVersion from './RatingV2'
// import RatingV2 from './RatingV2'
export default function RenderFilterOptions(props) {
  // const number = '0000'
  const { listData, setListData, dynamicListInfo } = props
  const [fromDateValue, setFromDateValue] = useState()
  const [toDateValue, setToDateValue] = useState()
  const [ageRatingValue, setAgeRatingValue] = useState()
  // const [toMovieRatingV2, setToMovieRatingV2] = useState()
  // const [fromMovieRatingV2, setFromMovieRatingV2] = useState()
  // let ratings = []

  // const selectedFromRating = ratings && ratings.filter(item => item.value === listData.fromRating)
  // const selectedToRating = ratings && ratings.filter(item => item.value === listData.toRating)
  const [fromMovieRating, setFromMovieRating] = useState(listData.fromRating)
  const [tomovieRating, setToMovieRating] = useState(listData.toRating)

  const genres = props.configData && props.configData.genres ? props.configData.genres : []
  // const configRatings = props.configData && props.configData.ratings ? props.configData.ratings : []
  const ottList = props.configData && props.configData.ottList ? props.configData.ottList : []
  const ageRestrictionFilters =
    props.configData && props.configData.ageRestrictionFilters
      ? props.configData.ageRestrictionFilters
      : []

  // let FromdateTime = getFormattedDate(listData.fromDate)
  // let todateTime = getFormattedDate(listData.toDate)

  const sortByValues = [
    {
      value: 'releaseYear',
      label: 'Release Year',
    },
    {
      value: 'popularity',
      label: 'Popularity',
    },
  ]
  // let ratings = []
  // if (configRatings) {
  // ratings = configRatings.map(item => ({
  //   value: item.rating,
  //   label: item.rating,
  // }))
  // }

  const genreHandle = e => {
    props.setDisableUpdateButton(false)

    //   e.map(e => e.label),
    //   'genre',
    // )
    const listDataTemp = { ...listData }

    const genreValues = e.map(e => e.label)
    const genreValuesTe = e.map(e => e.label_Te)
    if (e.length > 0) {
      dynamicListInfo.genre_En = genreValues
      dynamicListInfo.genre_Te = genreValuesTe
    } else {
      delete dynamicListInfo.genre_En
      delete dynamicListInfo.genre_Te
    }

    listDataTemp.genre_En = e.map(e => e.label)
    listDataTemp.genre_Te = e.map(e => e.label_Te)
    setListData(listDataTemp)
  }

  let ottPlatforms = []
  if (ottList) {
    ottPlatforms = ottList.map(item => ({
      value: item.label,
      label: item.label,
    }))
  }

  // dynamicListInfo.sortBy = listData.sortBy

  const handleList = (data, e) => {
    props.setDisableUpdateButton(false)

    const date = e.target.value.replace('-', '')
    if (data === 'fromDate') {
      listData.fromDate = date.replaceAll('-', '')
      dynamicListInfo.fromDate = date.replaceAll('-', '')

      // FromdateTime = e.target.value
      setFromDateValue(e.target.value)
    } else {
      listData.toDate = date.replaceAll('-', '')

      dynamicListInfo.toDate = date.replace('-', '')

      setToDateValue(e.target.value)
      // todateTime = e.target.value
    }
  }

  const clearRating = () => {
    props.setDisableUpdateButton(false)
    setToMovieRating('')
    setFromMovieRating('')
    // setFromMovieRatingV2('')
    // setToMovieRatingV2('')
    listData.fromRating = ''
    listData.toRating = ''
    delete dynamicListInfo.fromRating
    delete dynamicListInfo.toRating
    delete dynamicListInfo.fromRatingV2
    delete dynamicListInfo.toRatingV2
  }

  // useEffect(() => {
  //   const selectedFromRating = ratings && ratings.filter(item => item.value === listData.fromRating)
  //   const selectedToRating = ratings && ratings.filter(item => item.value === listData.toRating)
  //   setToMovieRating(selectedToRating)
  //   setFromMovieRating(selectedFromRating)
  // }, [ratings])

  // useEffect(() => {
  //   props.handleListData('sortBy', 'releaseYear')
  // }, [])

  const clearAgeRating = () => {
    props.setDisableUpdateButton(false)

    setAgeRatingValue([])
    listData.ageRestriction = []
    delete dynamicListInfo.ageRestriction
  }

  const clearDateValue = () => {
    props.setDisableUpdateButton(false)

    setFromDateValue(new Date())
    setToDateValue(new Date())
    // listData.fromDate = new Date()
    // listData.toDate = new Date()
    delete listData.fromDate
    delete listData.toDate
    delete dynamicListInfo.fromDate
    delete dynamicListInfo.toDate
  }

  useEffect(() => {
    setAgeRatingValue({
      label: listData.ageRestriction,
      value: listData.ageRestriction,
    })
    // setRating()
    // const selectedFromRating = ratings && ratings.filter(item => item.value === listData.fromRating)
    // const selectedToRating = ratings && ratings.filter(item => item.value === listData.toRating)

    setToMovieRating(dynamicListInfo.toRating)
    setFromMovieRating(dynamicListInfo.fromRating)
    // setToMovieRatingV2(dynamicListInfo.toMovieRatingV2)
    // setFromMovieRatingV2(dynamicListInfo.fromMovieRatingV2)
    setToDateValue(getFormattedDate(listData.toDate))
    setFromDateValue(getFormattedDate(listData.fromDate))
  }, [listData, dynamicListInfo])

  return (
    <div>
      <div>
        <label>Filters</label>
      </div>
      {/* <div> */}
      <PopularListTypeInMovies
        mode={props.mode}
        handleListData={props.handleListData}
        listData={listData}
      />

      <div className='d-flec flex-column gap-3 '>
        <div className='d-flex gap-3'>
          <div className='form-group col-md-3 p-0'>
            <label htmlFor='GenreFilter'>Genre</label>
            <Select
              isMulti
              placeholder='Select Genre'
              options={genres}
              value={listData.genre_En ? listData.genre_En.map(e => ({ label: e, value: e })) : []}
              name='genre'
              className='basic-multi-select'
              classNamePrefix='select'
              onChange={e => genreHandle(e)}
            />
          </div>
          <div className='form-group '>
            {/* <label htmlFor='RatingFilter'>Rating</label> */}
            <div className='d-flex gap-1 align-items-end'>
              <div className='d-flex flex-column' style={{ width: '10rem' }}>
                {' '}
                <lable>
                  <b>From rating</b>{' '}
                </lable>
                <input
                  style={{ width: '10rem' }}
                  placeholder='Enter From Rating'
                  // options={ratings}
                  value={fromMovieRating}
                  name='ratings'
                  className='rounded'
                  // classNamePrefix='select'
                  onChange={e => props.handleListData('fromRating', e.target.value)}
                />
              </div>
              <div className='d-flex flex-column ' style={{ width: '10rem' }}>
                <lable>
                  <b>To rating</b>
                </lable>
                <input
                  style={{ width: '10rem' }}
                  placeholder='Enter To Rating'
                  // options={ratings}
                  value={tomovieRating}
                  name='ratings'
                  className='rounded'
                  // classNamePrefix='select'
                  onChange={e => props.handleListData('toRating', e.target.value)}
                />
              </div>
              <button
                onClick={clearRating}
                className='btn btn-primary p-1'
                style={{ width: '4rem', height: '2rem' }}
              >
                x
              </button>
            </div>
            <lable style={{ color: 'red', fontSize: '10px' }}>
              To rating must be greater than From rating
            </lable>
          </div>
        </div>
        <RatingVersion dynamicListInfo={dynamicListInfo} handleListData={props.handleListData} />
        {/* </div> */}
        <div className='d-flex gap-2 align-items-center my-4'>
          <div>
            <label htmlFor='ReleaseYearFilter'>From Release Year</label>
            <div>
              <input
                style={{ width: '11rem', height: '2rem' }}
                type='date'
                onChange={e => handleList('fromDate', e)}
                value={fromDateValue}
                placeholder='Choose Start year'
              ></input>
            </div>
          </div>
          <div className=' '>
            <label htmlFor='ReleaseYearFilter'>To Release Year</label>
            <div className='d-flex gap-2'>
              <input
                style={{ width: '11rem', height: '2rem' }}
                type='date'
                onChange={e => handleList('toDate', e)}
                value={toDateValue}
                placeholder='Choose Start year'
              ></input>
              <button
                onClick={clearDateValue}
                className='btn btn-primary p-1 m-1 '
                style={{ height: '2rem', width: '1.5rem' }}
              >
                x
              </button>
            </div>
          </div>
        </div>
        <div className='d-flex gap-3 align-items-center mb-4'>
          <div className='d-flex align-items-center ' style={{ width: '10rem' }}>
            <div className='form-group  '>
              <label htmlFor='AgeRatingFilter'>Age Rating</label>
              <div className='d-flex gap-2'>
                <Select
                  placeholder='Select Age Rating'
                  options={ageRestrictionFilters}
                  value={ageRatingValue}
                  name='ageRatings'
                  className='basic-multi-select '
                  classNamePrefix='select'
                  onChange={e => props.handleListData('ageRestriction', e.value)}
                />
                <button
                  onClick={clearAgeRating}
                  className='btn btn-primary p-1 m-1'
                  style={{ height: '2rem', width: '1.5rem' }}
                >
                  x
                </button>
              </div>
            </div>
          </div>
          <div className='form-group '>
            <label htmlFor='SortByFilter'>Sort By</label>
            <Select
              placeholder='Select Sort By'
              options={sortByValues}
              value={
                listData.sortBy === 'popularity' || listData.sortBy === 'releaseYear'
                  ? { label: listData.sortBy, value: listData.sortBy }
                  : { label: 'releaseYear', value: 'releaseYear' }
              }
              name='sortBy'
              className='basic-multi-select '
              classNamePrefix='select'
              onChange={e => props.handleListData('sortBy', e.value)}
            />
          </div>
          <div className='form-group '>
            <label htmlFor='ottPlatformFilter'>Ott Platform</label>
            <Select
              isMulti
              placeholder='Select Ott Platform'
              options={ottPlatforms}
              value={
                listData.ottPlatform ? listData.ottPlatform.map(e => ({ label: e, value: e })) : []
              }
              name='ottPlatform'
              className='basic-multi-select '
              classNamePrefix='select'
              onChange={e =>
                props.handleListData(
                  'ottPlatform',
                  e.map(e => e.label),
                )
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}
